"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanySortField = exports.ActivitySubType = exports.ActivityType = void 0;
var ActivityType;
(function (ActivityType) {
    ActivityType["SHARES"] = "SHARES";
    ActivityType["COMPANY_INFORMATION"] = "COMPANY INFORMATION";
    ActivityType["REGISTER"] = "REGISTER";
})(ActivityType = exports.ActivityType || (exports.ActivityType = {}));
var ActivitySubType;
(function (ActivitySubType) {
    ActivitySubType["SET_SHARE_PRICE"] = "SET SHARE PRICE";
    ActivitySubType["SHARE_CLASS_CREATED"] = "SHARE CLASS CREATED";
    ActivitySubType["APPOINT_OFFICER"] = "APPOINT OFFICER";
    ActivitySubType["REMVOVE_OFFICER"] = "REMOVE OFFICER";
    ActivitySubType["CHANGE_ADDRESS"] = "CHANGE ADDRESS";
    ActivitySubType["SHARE_ISSUE"] = "SHARE ISSUE";
    ActivitySubType["SHARE_TRANSFER"] = "SHARE TRANSFER";
})(ActivitySubType = exports.ActivitySubType || (exports.ActivitySubType = {}));
var CompanySortField;
(function (CompanySortField) {
    CompanySortField["LAST_ACCESS"] = "lastAccess";
    CompanySortField["COMPANY_NAME"] = "companyName";
})(CompanySortField = exports.CompanySortField || (exports.CompanySortField = {}));
//# sourceMappingURL=index.js.map